import { Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

type IconSelectToolProps = {
  onChange: (value: string) => void;
  icon: any;
  options: string[];
  currentOption: string;
  fourIcon: any[];
};

function capitalize(elem: string) {
  return elem.charAt(0).toUpperCase() + elem.slice(1).toLowerCase();
}

export default function IconSelectTool(props: IconSelectToolProps) {
  const { onChange, options, currentOption, fourIcon } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [selectedOption, setselectedOption] = useState(
    capitalize(currentOption)
  );

  return (
    <>
      <button
        style={{
          border: 'none',
          background: 'transparent',
          width: '100%',
          padding: 0,
        }}
        onClick={handleClick}
      >
        {fourIcon.find(i => (i.value as string) === selectedOption)?.elem}
      </button>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        className={'customSelectPopover'}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {options &&
          options.length &&
          options.map((opt, index) => {
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  setselectedOption(opt);
                  console.log('opt', opt);
                  onChange(opt);
                }}
              >
                {fourIcon[index].elem}
                <div style={{ marginLeft: 10 }}>{opt}</div>
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
}
